// Styles
import './template-cart.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCart = (context) => {
  const templateCartSection = context.closest('.shopify-section');
  if (!templateCartSection) return;

  var $form = $(templateCartSection).find('#cart-form');
  if ($form.length <= 0) return;

  $form.find('[type="submit"][name="update"]').on('mousedown', function () {
    $form.off('submit.Parsley');
  });

  const updateCartPage = () => {
    $(context).addClass('is-loading');
    $.post(window.Shopify.routes.root + 'cart/update.js', $form.serialize(), (data) => {
      if (data.items.length <= 0) {
        location.reload();
      } else {
        var selectorToRemove = '.cart__form__row--product';
        data.items.forEach(lineItem => {
          const $el = $form.find('#line-item--' + lineItem.id);
          if ($el.length > 0) {
            const $priceLabel = $el.find('[data-original-price]');
            if ($priceLabel.length > 0) {
              $priceLabel.text(theme.Currency.formatMoney(lineItem.original_line_price, theme.strings.moneyFormat));
            }

            const $qty = $el.find('.js-qty');
            if ($qty.length > 0) {
              const $label = $qty.find('.js-qty__num');
              if ($label.length) {
                $label.val(lineItem.quantity);
              }

              const $removeButton = $qty.find('.js-qty__adjust--minus');
              if (lineItem.quantity <= 1) {
                $removeButton.attr('disabled', '');
              }
            }
          }
          selectorToRemove += ':not(#line-item--' + lineItem.id + ')';
        });
        const $totalPrice = $form.find('[data-total-price]');
        if ($totalPrice.length > 0) {
          $totalPrice.text(theme.Currency.formatMoney(data.total_price, theme.strings.moneyFormat));
        }
        const $toRemove = $form.find(selectorToRemove);
        if ($toRemove.length > 0) {
          $toRemove.remove();
        }
      }
      $(context).removeClass('is-loading');
    }, 'json')
      .catch(err => {
        console.log('$.post() error:', err);
      });
  };

  $form.find('.cart__form__meta__remove a').on('click', function (e) {
    e.preventDefault();

    $(this).closest('.cart__form__row').find('.js-qty__num').val(0);
    updateCartPage();
  });

  const initNumberInputs = () => {
    $form.find('.js-qty button').on('click', function () {
      const $qtyContainer = $(this).closest('.cart__form__row__element--quantity');
      if ($qtyContainer.data().stock) {
        const stock = parseInt($qtyContainer.data().stock);
        const $value = $(this).closest('.js-qty').find('.js-qty__num');
        const $addButton = $(this).closest('.js-qty').find('.js-qty__adjust--plus');

        if (stock <= parseInt($value.val())) {
          $addButton.attr('disabled', '');
        } else {
          $addButton.removeAttr('disabled', '');
        }
      }

      updateCartPage();
    });

    $form.find('.cart__form__row--product .cart__form__row__element--quantity').each(function () {
      const $value = $(this).find('.js-qty__num');
      const $addButton = $(this).find('.js-qty__adjust--plus');

      if ($(this).data().stock && $addButton.length > 0) {
        const stock = parseInt($(this).data().stock);

        if (stock < parseInt($value.val())) {
          $value.val(stock);
          updateCartPage();
        }

        if (stock == parseInt($value.val())) {
          $addButton.attr('disabled', '');
        }
      }

      const $removeButton = $(this).find('.js-qty__adjust--minus');
      if ($removeButton.length > 0 && parseInt($value.val()) <= 1) {
        $removeButton.attr('disabled', '');
      }

      $(this).removeClass('hidden-before-js');
    });
  }

  if (typeof (window.dAgency.initNumberInputs) !== 'undefined' && window.dAgency.initNumberInputs) {
    initNumberInputs();
  } else {
    $(document).on('InitializedNumberInputs', function () {
      initNumberInputs();
    });
  }

  var countrySelector = document.querySelector('select[name="country"]');
  var provinceSelector = document.querySelector('select[name="province"]');
  var defaultCountry = countrySelector.getAttribute('data-default');

  if (defaultCountry) {
    for (var i = 0; i !== countrySelector.options.length; ++i) {
      if (countrySelector.options[i].text === defaultCountry) {
        countrySelector.setAttribute('selectedIndex', i);
        break;
      }
    }
  } else {
    countrySelector.setAttribute('selectedIndex', 0);
  }

  var onCountryChanged = function() {
    var selectedOption = countrySelector.options[countrySelector.selectedIndex];
    var provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');
    console.log(provinces);
    if (provinces.length === 0) {
      provinceSelector.parentElement.style.display = 'none';
    } else {
      provinceSelector.innerHTML = '';
      provinces.forEach(function (data, index) {
        provinceSelector.options.add(new Option(data[1], data[0]));
      });
      provinceSelector.parentElement.style.display = 'block';
    }
  }

  onCountryChanged();

  countrySelector.addEventListener('change', function() {
    onCountryChanged();
  })

  var fetchRates = function() {
    var country = document.querySelector('[name="country"]').value,
        province = document.querySelector('[name="province"]').value,
        zip = document.querySelector('[name="zip"]').value;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch('/cart/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      response.json().then(function (result) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        var resultsContainer = document.querySelector('.ShippingEstimator__Results'),
            errorContainer = document.querySelector('.ShippingEstimator__Error');

        if (response.ok) {
          var shippingRates = result['shipping_rates'];

          if (shippingRates.length === 0) {
            resultsContainer.innerHTML = '<p>' + window.languages.shippingEstimatorNoResults + '</p>';
          } else {
            var html = '';

            if (shippingRates.length === 1) {
              html += '<p>' + window.languages.shippingEstimatorOneResult + '</p><ul>';
            } else {
              html += '<p>' + window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length) + '</p><ul>';
            }

            shippingRates.forEach(function (item) {
              html += '<li>' + item['name'] + ': ' +theme.Currency.formatMoney(item['price'], theme.strings.moneyFormat) + '</li>';
            });

            html += '</ul>';

            resultsContainer.firstElementChild.innerHTML = html;
          }

          errorContainer.style.display = 'none';
          resultsContainer.style.display = 'block';
          resultsContainer.style.height = 'auto';

        } else {
          var errorHtml = '';

          Object.keys(result).forEach(function (key) {
            errorHtml += '<li class="Alert__ErrorItem">' + key + ' ' + result[key] + '</li>';
          });

          errorContainer.innerHTML = '<ul class="Alert__ErrorList">' + errorHtml + '</ul>';

          resultsContainer.style.display = 'none';
          errorContainer.style.display = 'block';
        }
      });
    });
  };

  $('.ShippingEstimator__Submit').on('click', function(){
    fetchRates();
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
    window.dAgency.initTemplateCart(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
      window.dAgency.initTemplateCart(el);
    });
  });
}
